import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  CircularProgress,
} from '@mui/material';
import {Refresh as RefreshIcon} from '@mui/icons-material';

const StatisticsTab = ({stats, statsLoading, onRefresh}) => {
  return (
    <Card>
      <CardContent>
        <Box
          display='flex'
          justifyContent='space-between'
          alignItems='center'
          mb={2}
        >
          <Typography variant='h6'>Statistics</Typography>
          <Button
            variant='outlined'
            startIcon={<RefreshIcon />}
            onClick={onRefresh}
            disabled={statsLoading}
          >
            Refresh
          </Button>
        </Box>
        {statsLoading ? (
          <Box display='flex' justifyContent='center' p={4}>
            <CircularProgress />
          </Box>
        ) : stats ? (
          <Grid container spacing={2}>
            <Grid item xs={12} md={2}>
              <Card variant='outlined'>
                <CardContent>
                  <Typography color='textSecondary' gutterBottom>
                    Total Data
                  </Typography>
                  <Typography variant='h4'>{stats.totalData}</Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={2}>
              <Card variant='outlined'>
                <CardContent>
                  <Typography color='textSecondary' gutterBottom>
                    Valid Data
                  </Typography>
                  <Typography variant='h4' color='success.main'>
                    {stats.validData}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={2}>
              <Card variant='outlined'>
                <CardContent>
                  <Typography color='textSecondary' gutterBottom>
                    Invalid Data
                  </Typography>
                  <Typography variant='h4' color='error.main'>
                    {stats.invalidData}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={2}>
              <Card variant='outlined'>
                <CardContent>
                  <Typography color='textSecondary' gutterBottom>
                    Dup - Free
                  </Typography>
                  <Typography variant='h4' color='warning.main'>
                    {stats.duplicatedFreeData || 0}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={2}>
              <Card variant='outlined'>
                <CardContent>
                  <Typography color='textSecondary' gutterBottom>
                    Dup - Sent
                  </Typography>
                  <Typography variant='h4' color='error.main'>
                    {stats.duplicatedSentData || 0}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={2}>
              <Card variant='outlined'>
                <CardContent>
                  <Typography color='textSecondary' gutterBottom>
                    Success Rate
                  </Typography>
                  <Typography variant='h4'>{stats.successRate}%</Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        ) : (
          <Button variant='outlined' onClick={onRefresh}>
            Load Statistics
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

StatisticsTab.propTypes = {
  stats: PropTypes.shape({
    totalData: PropTypes.number,
    validData: PropTypes.number,
    invalidData: PropTypes.number,
    duplicatedFreeData: PropTypes.number,
    duplicatedSentData: PropTypes.number,
    successRate: PropTypes.string,
  }),
  statsLoading: PropTypes.bool.isRequired,
  onRefresh: PropTypes.func.isRequired,
};

export default StatisticsTab;
